/**
 * TurnTo - Ratings and Reviews
 * Functions that support the TurnTo ratings and reviews
 * implementation. This is meant for small enhancements
 * that help bridge the gap between TurnTo capabilities
 * and UI/UX requirements.
 */

// Pixlee Type
declare const Pixlee: {
  init: (config: { apiKey: string }) => void;
  addCategoryWidget: (config: {
    accountId: string;
    categoryName: string;
    containerId: string;
    widgetId: string;
  }) => void;
  addSimpleWidget: (config: { containerId: string; widgetId: string }) => void;
  addProductWidget: (config: {
    accountId: string;
    containerId: string;
    parent_category: string;
    skuId: string;
    widgetId: string;
  }) => void;
  resizeWidget: () => void;
};

export const PixleeHook = {
  async mounted() {
    try {
      await this.loadPixlee();
      this.initPixlee();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Pixlee failed to load: ', e);
    }
  },
  loadPixlee() {
    return new Promise<void>((resolve, reject) => {
      const src = 'https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js';

      const scriptLoaded = Array.from(document.getElementsByTagName('script')).find(
        (script) => script.src === src
      );

      if (scriptLoaded) {
        return resolve();
      }

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.onload = () => resolve();
      s.onerror = reject;
      s.src = src;
      document.body.appendChild(s);
    });
  },
  initPixlee() {
    const {
      dataset: { accountId, apiKey, categoryName, containerId, skuId, widgetType, widgetId }
    } = this.el;
    const payload = { containerId, widgetId };

    Pixlee.init({ apiKey });
    switch (widgetType) {
      case 'product':
        Pixlee.addProductWidget({
          ...payload,
          accountId,
          parent_category: skuId,
          skuId
        });
        break;
      case 'category':
        Pixlee.addCategoryWidget({
          ...payload,
          accountId,
          categoryName
        });
        break;
      default:
        Pixlee.addSimpleWidget({
          ...payload
        });
    }
    Pixlee.resizeWidget();
  }
};
